import { HeaderFeaturesArticleSpeech } from "scmp-app/components/header/features/article-speech";
import type { HeaderFeaturesArticleSpeechProps } from "scmp-app/components/header/features/article-speech";
import { HeaderFeaturesBookmark } from "scmp-app/components/header/features/bookmark";
import type { HeaderFeaturesBookmarkProps } from "scmp-app/components/header/features/bookmark";
import type { HeaderFeaturesCommentProps } from "scmp-app/components/header/features/comment";
import { HeaderFeaturesComment } from "scmp-app/components/header/features/comment";
import { HeaderFeaturesDashboard } from "scmp-app/components/header/features/dashboard";
import type { HeaderFeaturesDashboardProps } from "scmp-app/components/header/features/dashboard";
import { HeaderFeaturesHamburgerMenu } from "scmp-app/components/header/features/hamburger-menu";
import type { HeaderFeaturesHamburgerMenuProps } from "scmp-app/components/header/features/hamburger-menu";
import { HeaderFeaturesLogoLink } from "scmp-app/components/header/features/logo-link";
import type { HeaderFeaturesLogoLinkProps } from "scmp-app/components/header/features/logo-link";
import { HeaderFeaturesLogoTextLink } from "scmp-app/components/header/features/logo-text-link";
import type { HeaderFeaturesLogoTextLinkProps } from "scmp-app/components/header/features/logo-text-link";
import { HeaderFeaturesMyNews } from "scmp-app/components/header/features/my-news";
import type { HeaderFeaturesMyNewsProps } from "scmp-app/components/header/features/my-news";
import type { HeaderFeaturesNewsletterProps } from "scmp-app/components/header/features/newsletter";
import { HeaderFeaturesNewsletter } from "scmp-app/components/header/features/newsletter";
import { HeaderFeaturesOneLineMenu } from "scmp-app/components/header/features/one-line-menu";
import type { HeaderFeaturesOneLineMenuProps } from "scmp-app/components/header/features/one-line-menu";
import { HeaderFeaturesSearch } from "scmp-app/components/header/features/search";
import type { HeaderFeaturesSearchProps } from "scmp-app/components/header/features/search";
import type { HeaderFeaturesShareProps } from "scmp-app/components/header/features/share";
import { HeaderFeaturesShare } from "scmp-app/components/header/features/share";
import { HeaderFeaturesStyleLogoLink } from "scmp-app/components/header/features/style-logo-link";
import type { HeaderFeaturesStyleLogoLinkProps } from "scmp-app/components/header/features/style-logo-link";
import { HeaderFeaturesStyleTextLink } from "scmp-app/components/header/features/style-text-link";
import type { HeaderFeaturesStyleTextLinkProps } from "scmp-app/components/header/features/style-text-link";
import type { HeaderFeaturesSubscriptionProps } from "scmp-app/components/header/features/subscription";
import { HeaderFeaturesSubscription } from "scmp-app/components/header/features/subscription";

export const useHeaderFeaturesProvider = () => {
  const headerFeatureProvider = {
    articleSpeech: ({ shouldSwap, showIn, showOnSwap }: HeaderFeaturesArticleSpeechProps = {}) => (
      <HeaderFeaturesArticleSpeech
        shouldSwap={shouldSwap}
        showIn={showIn}
        showOnSwap={showOnSwap}
      />
    ),
    bookmark: ({ shouldSwap, showIn, showOnSwap }: HeaderFeaturesBookmarkProps = {}) => (
      <HeaderFeaturesBookmark shouldSwap={shouldSwap} showIn={showIn} showOnSwap={showOnSwap} />
    ),
    comment: ({ shouldSwap, showIn, showOnSwap }: HeaderFeaturesCommentProps = {}) => (
      <HeaderFeaturesComment shouldSwap={shouldSwap} showIn={showIn} showOnSwap={showOnSwap} />
    ),
    dashboard: ({
      hideOnSwap,
      isHomepage,
      shouldSwap,
      showIn,
    }: HeaderFeaturesDashboardProps = {}) => (
      <HeaderFeaturesDashboard
        hideOnSwap={hideOnSwap}
        isHomepage={isHomepage}
        shouldSwap={shouldSwap}
        showIn={showIn}
      />
    ),
    hamburgerMenu: ({ showIn }: HeaderFeaturesHamburgerMenuProps = {}) => (
      <HeaderFeaturesHamburgerMenu showIn={showIn} />
    ),
    logoLink: ({ shouldSwap, showIn, showOnSwap }: HeaderFeaturesLogoLinkProps = {}) => (
      <HeaderFeaturesLogoLink shouldSwap={shouldSwap} showIn={showIn} showOnSwap={showOnSwap} />
    ),
    logoTextLink: ({
      hideOnSwap,
      shouldSwap,
      showIn,
      variant,
    }: HeaderFeaturesLogoTextLinkProps = {}) => (
      <HeaderFeaturesLogoTextLink
        hideOnSwap={hideOnSwap}
        shouldSwap={shouldSwap}
        showIn={showIn}
        variant={variant}
      />
    ),
    myNews: ({ showIn }: HeaderFeaturesMyNewsProps = {}) => (
      <HeaderFeaturesMyNews showIn={showIn} />
    ),
    newsletter: ({ showIn }: HeaderFeaturesNewsletterProps = {}) => (
      <HeaderFeaturesNewsletter showIn={showIn} />
    ),
    oneLineMenu: ({ appBarVariant, initEdition }: HeaderFeaturesOneLineMenuProps = {}) => (
      <HeaderFeaturesOneLineMenu appBarVariant={appBarVariant} initEdition={initEdition} />
    ),
    search: ({ showIn }: HeaderFeaturesSearchProps = {}) => (
      <HeaderFeaturesSearch showIn={showIn} />
    ),
    share: ({ shouldSwap, showIn, showOnSwap }: HeaderFeaturesShareProps = {}) => (
      <HeaderFeaturesShare shouldSwap={shouldSwap} showIn={showIn} showOnSwap={showOnSwap} />
    ),
    styleLogoLink: ({ shouldSwap, showIn, showOnSwap }: HeaderFeaturesStyleLogoLinkProps = {}) => (
      <HeaderFeaturesStyleLogoLink
        shouldSwap={shouldSwap}
        showIn={showIn}
        showOnSwap={showOnSwap}
      />
    ),
    styleTextLink: ({ shouldSwap, showIn, showOnSwap }: HeaderFeaturesStyleTextLinkProps = {}) => (
      <HeaderFeaturesStyleTextLink
        shouldSwap={shouldSwap}
        showIn={showIn}
        showOnSwap={showOnSwap}
      />
    ),
    subscription: ({
      isMagazineStyle,
      shouldSwap,
      showIn,
      showOnSwap,
    }: HeaderFeaturesSubscriptionProps = {}) => (
      <HeaderFeaturesSubscription
        isMagazineStyle={isMagazineStyle}
        shouldSwap={shouldSwap}
        showIn={showIn}
        showOnSwap={showOnSwap}
      />
    ),
  };
  return headerFeatureProvider;
};
